import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VehicleCheck } from '../../entity/other-entities/vehicle-check';
import Enums from '../../utils/enums';
import { FinesService } from '../../service/main/fines.service';
import { ToastrService } from '../../service/common/toastr.service';


declare var jsPDF: any;

@Component({
    selector: 'app-vehicle-check-details',
    templateUrl: './vehicle-check-details.component.html'
})
export class VehicleCheckDetailsComponent implements OnInit {
    vehicleCheck: VehicleCheck;
    selectedImage = '';

    constructor(
        private route: ActivatedRoute,
        private finesService: FinesService,
        private toastrService: ToastrService
    ) { }

    ngOnInit() {
        this.refresh();
    }

    refresh() {
        const vehicleCheck = new VehicleCheck();
        vehicleCheck.fromObject(this.route.snapshot.data['vehicleCheck']);

        this.vehicleCheck = vehicleCheck;
    }

    printFine() {
        const mywindow = <any>window.open('', 'PRINT', 'height=800,width=1200');
        mywindow.document.write('<html><head><title></title>');
        mywindow.document.write('</head><body >');
        mywindow.document.write('<h1>' + document.title + '</h1>');
        mywindow.document.write(
            `
            <div class="img-container">
                <img src="${this.vehicleCheck.Pictures[0]}" alt="" height="300" width="auto">
                <img src="${this.vehicleCheck.Pictures[1]}" alt="" height="300" width="auto">
                <img src="${this.vehicleCheck.Pictures[2]}" alt="" height="300" width="auto">
                <img src="${this.vehicleCheck.Pictures[3]}" alt="" height="300" width="auto">
            </div>
            <div class="print">
                <table style="width: 100%;">
                    <tr>
                        <th colspan=2>Amenda</th>
                    </tr>
                    <tr>
                        <td>Data</td>
                        <td>${this.vehicleCheck.Date}</td>
                    </tr>
                    <tr>
                        <td>Zona</td>
                        <td>${this.vehicleCheck.Parking}</td>
                    </tr>
                    <tr>
                        <td>Parcare</td>
                        <td>${this.vehicleCheck.ParkingName}</td>
                    </tr>
                    <tr>
                        <td>Latitudine</td>
                        <td>${this.vehicleCheck.Latitude}</td>
                    </tr>
                    <tr>
                        <td>Longitudine</td>
                        <td>${this.vehicleCheck.Longitude}</td>
                    </tr>
                    <tr>
                        <th colspan=2>Autor</th>
                    </tr>
                    <tr>
                        <td>Nume</td>
                        <td>${this.vehicleCheck.AuthorName}</td>
                    </tr>
                    <tr>
                        <th colspan=2>Vehicul</th>
                    </tr>
                    <tr>
                        <td>Numar inmatriculare</td>
                        <td>${this.vehicleCheck.Plate}</td>
                    </tr>
                </table>
            </div>
            <style>
                * {
                    font-family: Arial;
                }
                .print {
                    margin-top: 20px;
                }
                table {
                    border-collapse: collapse;
                    border: 1px solid black !important;
                }
                tr {
                    border: 1px solid black !important;
                    padding: 5px;
                }
                td {
                    border: 1px solid black !important;
                    padding: 5px;
                }
                .img-container {
                    text-align: center;
                }
                th {
                    text-align: left;
                    padding: 5px;
                }
            </style>
            `
        );
        mywindow.document.write('</body></html>');

        mywindow.document.close();
        mywindow.focus();

        mywindow.print();
        mywindow.close();
    }

    selectImage(url: string): void {
        this.selectedImage = url;
    }

    onPreviewClose(): void {
        this.selectImage('');
    }
}
